import {
  EnquiryFeature,
  EnquiryStatus,
  IEnquiryCreatePayload,
} from '@/types/enquiry'
import { ApiService } from './ApiService'
import qs from 'query-string'
import { IPaginationParams } from '@/types/api'

export type IEnquiryFilters = {
  featureRequest?: EnquiryFeature
  course?: string
  status?: EnquiryStatus
  assignee?: string
  customer?: string
  reporter?: string
}

export class EnquiryService extends ApiService {
  static RESOURCE_PATH = '/enquiries'

  static async getEnquiries(
    filters: IEnquiryFilters,
    pagination: IPaginationParams
  ) {
    const queryString = qs.stringify({ ...filters, ...pagination })

    return ApiService.get(`${EnquiryService.RESOURCE_PATH}?${queryString}`)
  }

  static async postEnquiry(payload: IEnquiryCreatePayload) {
    return ApiService.post(EnquiryService.RESOURCE_PATH, payload)
  }
}
